import React, { useState, useEffect } from 'react'
import SidebarProposal from '../../../layouts/sidebarProposal/SidebarProposal'
import { startLoading, doneLoading } from '../../../utils/loading'
import ContentHeader from '../../../components/ContentHeader/ContentHeader'
import PanalLoadingTemplate from '../../../widgets/loadingTemplate/panalLoadingTemplate/PanalLoadingTemplate'
import ErrorWidget from '../../../widgets/errorWidget/ErrorWidget'
import DocumentOfTerminationWidget from '../../../widgets/documentOfTermination/DocumentOfTerminationWidget'
import { getTerminate } from '../../../redux/actions/documentOfTermination'

export default function DocumentOfTermination() {
  const [schema, setSchema] = useState()
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState()

  useEffect(() => {
    handleGetSchema()
  }, [])

  const handleGetSchema = async () => {
    setIsLoading(true)
    startLoading()
    try {
      const _schema = await getTerminate()
      // console.log('_schema ', _schema)
      if (_schema) {
        setSchema(_schema)
      }
    } catch (e) {
      // console.log('error', e)
      if (e?.response?.data) {
        setError({
          statusCode: e.response.data.status,
          errorMessage: e.response.data.errors?.message,
        })
      } else {
        setError({})
      }
    }
    doneLoading()
    setIsLoading(false)
  }

  if (error) {
    return (
      <SidebarProposal isLegalManagement>
        <ErrorWidget statusCode={error.statusCode} errorMessage={error.errorMessage} />
      </SidebarProposal>
    )
  }

  if (!schema || isLoading) {
    return (
      <SidebarProposal isLegalManagement>
        <PanalLoadingTemplate />
      </SidebarProposal>
    )
  }

  return (
    <SidebarProposal isLegalManagement>
      <ContentHeader
        header={schema.header || 'จัดทำหนังสือบอกเลิก'}
        subHeader={schema.subHeader}
        isNotCallApi
      />

      <DocumentOfTerminationWidget schema={schema} />

      <br />
    </SidebarProposal>
  )
}
